<template>
    <section class="faq-section">
      <h2>Frequently Asked Questions</h2>
      <div class="faq-item" v-for="(item, index) in faqs" :key="index">
        <button class="faq-question" @click="toggleAnswer(index)">
          {{ item.question }} <span :class="{'active': item.open}"></span>
        </button>
        <div class="faq-answer" :class="{ 'open': item.open }">
          <p v-html="item.answer"></p>
        </div>
      </div>
      <p class="legend">Check out our <a href="/pages/faq">Help Center</a> for more FAQs</p>
    </section>
  </template>
  
  <script>
  export default {
    name: 'FaqSection',
    data() {
      return {
        faqs: [
          {
            question: "How are you different than other swag partners?",
            answer: `We’re so glad you asked! We are not your typical swag partner in mainly two ways:
                    <ol>
                        <li>We don’t have a catalog because we can source anything,</li>
                        <li>Most importantly, we are your gifting partner, meaning we project manage and ensure you’re satisfied while handling all the complex shipping you might need. Whether it’s shipping to one location, assembling swag kits, or shipping to hundreds of addresses, we’ve got you covered. We can even manage sizing for your recipients.</li>
                    </ol>`,
            open: false
          },
          {
            question: "What kind of swag can you do?",
            answer: `Truly the sky’s the limit - we have thousands of vendors & manufacturing partners who can create almost anything. Of course, we have relationships with some of the most popular swag brands out there: Yeti, Owala, The North Face, Carhartt, JBL, Bella + Canvas, and so, so many more. <a href="/pages/submit-an-inquiry-concierge-gifting" target="_blank">Inquire today</a> for a custom proposal today, or even if you’re looking for something specific or if you want us to recommend what’s on-trend right now.`,
            open: false
          },
          {
            question: "Can you make swag kits (in branded bags, boxes, or other packaging) for new hires or one-time events?",
            answer: `Oh boy, can we! We’re really, really good at this. <a href="https://happyboxstore.com/pages/corporate-gifts" target="_blank">Learn more about our flexible solutions</a> or <a href="/pages/contact" target="_blank">contact our corporate/bulk gifting sales team</a> via your preferred method to have a conversation about it.`,
            open: false
          },
          {
            question: "Do you ship internationally?",
            answer: `Yes we do!`,
            open: false
          },
          {
            question: "Can you store & warehouse my swag as I need it?",
            answer: `Absolutely, this is part of our premium ongoing gifting offering, which starts at $150/month for storage, warehousing, project management and shipping on-demand (plus a ton of other cool features like robust tracking and management in your custom private portal). Learn more <a href="/pages/corporate-gifts">here</a>, <a href="/pages/submit-an-inquiry-concierge-gifting">inquire via this form</a>, or <a href="https://calendar.app.google/BS3epNk6LrNPc7ca6">book a call</a> with our team for a custom proposal!`,
            open: false
          }
        ]
      };
    },
    methods: {
      toggleAnswer(index) {
        this.faqs.forEach((faq, i) => {
          if (i === index) {
            faq.open = !faq.open;
          } else {
            faq.open = false;
          }
        });
      }
    }
  };
  </script>
  <style>
  .faq-section a{
		color: #A01ADB;
		text-decoration: underline;
		font-weight: bold;
	}
  </style>
  <style scoped>
  .faq-section {
    padding: 5% 15%;
    margin: 0 auto;
    border-radius: 10px;
  }
  
  .faq-answer a {
    color: #A01ADB;
    text-decoration: underline;
    font-weight: bold;
  }
  
  .faq-section .legend {
    margin-top: 5%;
    text-align: center;
  }
  
  .faq-section h2 {
    margin-bottom: 2%;
    font-size: 4vw;
    line-height: 1;
    font-family: "ff-more-web-pro-condensed", "Karla", sans-serif;
    font-weight: 300;
    text-align: center;
  }
  
  .faq-item {
    border-bottom: 1px solid #e0e7ff;
    padding: 15px 0;
  }
  
  .faq-item:last-child {
    border-bottom: none;
  }
  
  .faq-question {
    background: none;
    border: none;
    width: 100%;
    text-align: left;
    font-size: 1.5vw;
    cursor: pointer;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    color: #0f0c38;
  }
  
  .faq-question span {
    transition: transform 0.3s;
    border: solid black;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 5px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }
  
  .faq-question.active span {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }
  
  .faq-answer {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.5s ease-out;
    padding: 0 10px;
    font-size: 1em;
    line-height: 1.5em;
  }
  
  .faq-answer.open {
    max-height: 200px; /* Adjust this value based on the content length */
    transition: max-height 0.5s ease-in;
  }

  @media screen and (max-width: 767px) {
    .faq-question{
			font-size: 4vw;
			width: 100%;
		}

    .faq-section h2{
			font-size: 8vw;
			padding: 0% 5%;
		}

    .faq-answer.open{
			max-height: 400px;
		}

    .faq-section {
      padding: 5%;
    }
  }
  </style>
  